import { DateFilter, IdFilter, StringFilter } from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";

export class RollCallFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public courseSectionId?: IdFilter = new IdFilter();
  public appUserId?: IdFilter = new IdFilter();
  public statusId?: IdFilter = new IdFilter();
  public semesterId?: IdFilter = new IdFilter();
  public classShiftId?: IdFilter = new IdFilter();
  public weekdayId?: IdFilter = new IdFilter();
  public subjectId?: IdFilter = new IdFilter();
  public organizationId?: IdFilter = new IdFilter();
  public name?: StringFilter = new StringFilter();
  public code?: StringFilter = new StringFilter();
  public updatedAt?: DateFilter = new DateFilter();
  public lessonDate?: DateFilter = new DateFilter();
  public search?: string = null;
}
